// frontend/src/services/document/editableTitleService.js
import api from '../api';
import errorService from '../error/errorService';

/**
 * EditableTitle Service - Handles document and project title operations
 */
class EditableTitleService {
  /**
   * Update document title
   * @param {string} documentId - The ID of the document
   * @param {string} title - The new title
   * @returns {Promise<Object>} - Promise that resolves with the updated document
   */
  async updateDocumentTitle(documentId, title) {
    try {
      const response = await api.put(`/documents/${documentId}/title`, { title });
      return response.data;
    } catch (error) {
      return errorService.handleApiError(error, 'Failed to update document title');
    }
  }

  /**
   * Update project title
   * @param {string} projectId - The ID of the project
   * @param {string} title - The new title
   * @returns {Promise<Object>} - Promise that resolves with the updated project
   */
  async updateProjectTitle(projectId, title) {
    try {
      const response = await api.put(`/projects/${projectId}/title`, { title });
      return response.data;
    } catch (error) {
      return errorService.handleApiError(error, 'Failed to update project title');
    }
  }
}

export default new EditableTitleService();